import studentOpportunityApi from "../../api/studentOpportunity";
import opportunityApi from "../../api/opportunity";

const state = {
  studentOpportunities: [],
  students: [],
  additionalMaterialStatuses: [],
  opportunityTypes: []
};

const actions = {
  getApplicationStatus(context, termId) {
    studentOpportunityApi
      .getApplicationStatus(termId)
      .then(function(response) {
        context.commit("updateStudentOpportunities", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getCompleted(context, termId) {
    studentOpportunityApi
      .getCompletedStudents(termId)
      .then(function(response) {
        context.commit("updateStudentOpportunities", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getPendingStudents(context, termId) {
    studentOpportunityApi
      .getPendingStudents(termId)
      .then(function(response) {
        context.commit("updateStudents", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getApprovedStudentOpportunities(context, termId) {
    studentOpportunityApi
      .getApprovedStudentOpportunities(termId)
      .then(function(response) {
        context.commit("updateStudentOpportunities", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getAdditionalMaterialStatuses(context) {
    studentOpportunityApi
      .getAdditionalMaterialStatuses()
      .then(function(response) {
        context.commit("updateAdditionalMaterialStatuses", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  getOpportunityTypes(context) {
    opportunityApi
      .getOpportunityTypes()
      .then(function(response) {
        context.commit("updateOpportunityTypes", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

const mutations = {
  updateStudentOpportunities(state, value) {
    state.studentOpportunities = value;
  },
  updateStudents(state, value) {
    state.students = value;
  },
  updateAdditionalMaterialStatuses(state, value) {
    state.additionalMaterialStatuses = value;
  },
  updateOpportunityTypes(state, value) {
    state.opportunityTypes = value;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
